(function () {
  if (window.__lumAnalyticsLoaded) return;
  window.__lumAnalyticsLoaded = true;
  function ga() {
    try {
      if (!window.__lumConsentBridge || !window.__lumConsentBridge.allowed()) return;
      if (window.__lumNativeRetailGa4 === true && ['page_view', 'view_item', 'add_to_cart', 'search'].indexOf(arguments[1]) !== -1) return;
      if (typeof window.gtag === 'function') {
        var args = Array.prototype.slice.call(arguments);
        if (args[0] === 'event') {
          args[2] = Object.assign({}, args[2] || {}, {send_to: 'G-VWMD5SJPG5'});
        }
        window.gtag.apply(null, args);
        return true;
      }
    } catch (e) {}
  }
  function commerceOwned() { return window.__lumThemeCommerce === true; }
  var formEvents = { contact: 'contact_inquiry_success', newsletter: 'newsletter_signup', job: 'job_application_success', clinic: 'clinic_inquiry_success', insurance: 'insurance_inquiry_success' };
  var pendingKey = 'lum.form.pending.v1';
  function remember(form) {
    var kind = form.getAttribute('data-analytics-form');
    if (!formEvents[kind]) return;
    if (!window.__lumConsentBridge || !window.__lumConsentBridge.allowed()) {
      form.__lumPending = null;
      try { sessionStorage.removeItem(pendingKey); } catch (e) {}
      return;
    }
    var pending = { id: form.id, kind: kind, path: location.pathname, time: Date.now() };
    form.__lumPending = pending;
    try { sessionStorage.setItem(pendingKey, JSON.stringify(pending)); } catch (e) {}
  }
  function complete(form, nativeReturn) {
    var kind = form.getAttribute('data-analytics-form');
    if (!formEvents[kind] || form.__lumReported) return;
    var pending = form.__lumPending;
    if (nativeReturn) {
      try { pending = JSON.parse(sessionStorage.getItem(pendingKey)); } catch (e) { return; }
      if (!pending || pending.id !== form.id || pending.kind !== kind || pending.path !== location.pathname || Date.now() - pending.time > 1800000 || Date.now() < pending.time) return;
    }
    if (!pending) return;
    form.__lumReported = true;
    form.__lumPending = null;
    try { sessionStorage.removeItem(pendingKey); } catch (e) {}
    ga('event', formEvents[kind], { form_type: kind });
  }
  document.querySelectorAll('[data-analytics-success]').forEach(function (marker) {
    var form = marker.closest('form');
    if (form) complete(form, true);
  });
  document.addEventListener('luminate:form-success', function (e) {
    if (e.target instanceof HTMLFormElement) complete(e.target, false);
  });
  document.addEventListener('luminate:cart-add-success', function (e) {
    if (!commerceOwned()) return;
    var d = e.detail || {}, item = d.item || {}, qty = Number(d.quantity);
    if (!item.variant_id || !Number.isInteger(qty) || qty < 1 || !Number.isFinite(item.price)) return;
    ga('event', 'add_to_cart', {
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD',
      value: item.price / 100 * qty,
      items: [{ item_id: String(item.variant_id), item_name: item.product_title, item_variant: item.variant_title, price: item.price / 100, quantity: qty }]
    });
  });
  var tpl = window.__lumTemplate || '';

  /* ---- page-type events ---- */

  // product page: view_item
  var productViewed = false;
  function productView() {
    if (productViewed) return;
    var pj = document.querySelector('[data-product-json]');
    if (commerceOwned() && tpl === 'product' && pj) {
      try {
        var product = JSON.parse(pj.textContent);
        var selected = document.querySelector('#ProductForm [name="id"]');
        var v = product.variants && product.variants.find(function (variant) { return selected && String(variant.id) === String(selected.value); });
        if (v) productViewed = ga('event', 'view_item', {
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD',
          value: v ? v.price / 100 : undefined,
          items: [{
            item_id: String(v ? v.id : product.id),
            item_name: product.title,
            item_brand: product.vendor,
            item_category: product.type || undefined,
            price: v ? v.price / 100 : undefined,
            quantity: 1
          }]
        });
      } catch (e) { /* no-op */ }
    }
  }
  document.addEventListener('luminate:analytics-ready', productView);
  productView();

  // practitioner profile: view_practitioner
  if (document.querySelector('.pract-bio')) {
    var pname = document.querySelector('h1');
    var prole = document.querySelector('.text-lg.text-primary');
    ga('event', 'view_practitioner', {
      practitioner_name: pname ? pname.textContent.trim() : '',
      service_type: prole ? prole.textContent.trim() : ''
    });
  }

  // brand page: view_brand
  var brandViewed = false;
  function brandView() {
    if (brandViewed) return;
    if (document.querySelector('[data-brand-root]')) {
      brandViewed = ga('event', 'view_brand', {
        brand_name: document.querySelector('[data-brand-root]').getAttribute('data-vendor') || ''
      });
    }
  }
  document.addEventListener('luminate:analytics-ready', brandView);
  brandView();

  // blog article: blog_read
  var articleRead = false;
  function articleView() {
    if (articleRead) return;
    if (tpl === 'article') {
      var at = document.querySelector('h1');
      articleRead = ga('event', 'blog_read', { article_title: at ? at.textContent.trim() : '' });
    }
  }
  document.addEventListener('luminate:analytics-ready', articleView);
  articleView();

  /* ---- interaction events (delegated) ---- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.hasAttribute('data-analytics-form')) {
      form.__lumReported = false;
      remember(form);
    }

    // search
    if (/\/search/.test(form.getAttribute('action') || '')) {
      var q = form.querySelector('input[name="q"]');
      if (q && q.value.trim()) ga('event', 'search', { search_term: q.value.trim() });
    }

  }, true);

  document.addEventListener('click', function (e) {
    var retail = e.target.closest && e.target.closest('[data-store-action]');
    if (retail) {
      var retailEvents = { call: 'store_call_click', directions_open: 'store_directions_open' };
      var retailEvent = retailEvents[retail.getAttribute('data-store-action')];
      var storeLocation = retail.getAttribute('data-store-location');
      var placement = retail.getAttribute('data-store-placement');
      if (typeof retailEvent === 'string' && ['bedford', 'dartmouth'].indexOf(storeLocation) !== -1 && ['location_card', 'footer', 'store_hero'].indexOf(placement) !== -1) {
        ga('event', retailEvent, { store_location: storeLocation, cta_placement: placement });
      }
    }
    // begin_checkout is sent by the GA4 customer-events pixel when checkout really
    // starts (it also sees Buy-it-now and Shop Pay); sending it here too counted it twice.
  }, true);
})();
